module.exports = __webpack_public_path__ + "img/item5.4acba391.png";